define('drops/treeView/treeView',[
    'lq',
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'underscore',
    './singleSelection',
    './multiSelection',
    'jqTree/tree.jquery',
    'lq/required'
], function (lq, $, Drop, Style, util,  _, SingleSelection, MultiSelection, jqTree, Required) {
    'use strict';

    var defaults = {
        data: {
            expandTreeOnLoad: true,
            multiselect: false,
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
}
    };

    function TreeView(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        var self = this;

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.$tree = $('<div/>');

        var $overflowElement = $('<div/>');
        $overflowElement.css({ 'overflow': 'auto', 'height': '100%', 'width': '100%' });
        $overflowElement.append(this.$tree);
        this.$element.append($overflowElement);

        this.initializeTree();

        if (this.data.useCustomNodeImages)
            this.$element.addClass('leaf-nodes-have-icons');
    };

    Drop.extend(TreeView, Drop);

    TreeView.typeName = 'TreeView';

    TreeView.prototype.initializeTree = function () {
        var self = this;

        var config = {
            data: [],
            autoOpen: this.data.expandTreeOnLoad,
            dragAndDrop: false,
            onCreateLi: function (node, $li) {
                var $element = $li.find('.jqtree-element').first();

                Style.renderStyles(self, null, $element);
                self.renderCustomColors($element, node);

                if (self.data.useCustomNodeImages) {
                    $element
                        .prepend($('<a class="default-leaf-node"></a>')
                            .append($('<img />').attr('src', lq.getTenantUploads(self.data.defaultLeafNodeImage)).css({verticalAlign: 'middle'})))
                        .prepend($('<a class="selected-leaf-node"></a>')
                            .append($('<img />').attr('src', lq.getTenantUploads(self.data.selectedLeafNodeImage)).css({verticalAlign: 'middle'})));
                }

                self.selection.onCreateLi(node, $element);

                $element.append(_.map(self.data.nodeActions, function (nodeAction, index) {
                    var $action = $('<img class="tree-node-action" />')
                        .addClass(nodeAction.visibility + '-visibility')
                        .attr('src', lq.getTenantUploads(nodeAction.image))
                        .attr('title', nodeAction.tooltip)
                        .css({verticalAlign: 'middle'});

                    if (nodeAction.resizeImage)
                        $action
                            .width(nodeAction.imageWidth + 'px')
                            .height(nodeAction.imageHeight + 'px');

                    if (self.data.nodeActionSpacing && index !== self.data.nodeActions.length - 1)
                        $action.css('margin-right', self.data.nodeActionSpacing + 'px');

                    if (nodeAction.enableDynamicVisibility && node.actionData != null && node.actionData.length > 0) {
                        var data = node.actionData[index];
                        if (!data.show) {
                            $action.hide();
                        }
                    }

                    if (nodeAction.eventing.clicked && nodeAction.eventing.clicked.enabled) {
                        $action.on('click', function () {
                            self.triggerEvent(nodeAction.eventing.clicked.raisedEventName, node.id, $action);
                            return false;
                        });
                    }

                    return $action;
                }).reverse());
            }
        };

        if (!this.isEventEnabled('deselected')) {
            config.onCanSelectNode = function (node) {
                return node.id !== self.idOfSelectedNode;
            };
        }

        if (this.data.useCustomNodeImages) {
            config.closedIcon = $('<img />').attr('src', lq.getTenantUploads(this.data.collapsedNodeImage)).css({verticalAlign: 'middle'});
            config.openedIcon = $('<img />').attr('src', lq.getTenantUploads(this.data.expandedNodeImage)).css({verticalAlign: 'middle'});
        }

        this.$tree.tree(config);
    };

    TreeView.prototype.renderNormalStyleForNode = function ($element, data) {
        Style.renderStyles(this, null, $element);
        this.overrideStylingIfNeeded($element, data);
    };

    TreeView.prototype.showAsDeselected = function (node) {
        var $element = $(node.element).find('.jqtree-element').first();
        $element.removeClass('selected');
    };

    TreeView.prototype.showAsSelected = function (node) {
        var $element = $(node.element).find('.jqtree-element').first();
        $element.addClass('selected');
    };

    TreeView.prototype.preRender = function () {
        var self = this;
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data) { self._update(data); },
            function (params) { }
        );
        Required.prototype.addRemoveRequiredIndicator(self);
        this.applyPosition();

        this.selection = this.data.multiselect ? new MultiSelection(this) : new SingleSelection(this);
    };

    TreeView.prototype.postRender = $.noop;

    TreeView.prototype.renderCustomColors = function($element, node) {
        if (node.textColor)
            $element.css('color', node.textColor);

        if (node.backgroundColor)
            $element.css('background', node.backgroundColor);
    };

    TreeView.prototype._update = function (data) {
        var state = this.$tree.tree('getState');

        var idProperty = this.data.idProperty;
        var parentIdProperty = this.data.parentIdProperty;
        var textProperty = this.data.textProperty;

        var treeViewItems = [];
        var treeViewItemsById = {};
        var rootTreeViewItems = [];

        var self = this;

        _.each(data.results, function (row) {
            var treeViewItem = {
                id: row[idProperty],
                label: row[textProperty],
                parentId: row[parentIdProperty],
                actionData: _.map(self.data.nodeActions, function (na) {
                        return {
                            'show': row[na['dynamicVisibility']]
                        };
                }),
                children: []
            };

            if (self.data.textColorProperty && row[self.data.textColorProperty])
                treeViewItem.textColor = row[self.data.textColorProperty];

            if (self.data.backgroundColorProperty && row[self.data.backgroundColorProperty])
                treeViewItem.backgroundColor = row[self.data.backgroundColorProperty];

            treeViewItems.push(treeViewItem);
            treeViewItemsById[treeViewItem.id] = treeViewItem;

            if (treeViewItem.parentId == null) {
                rootTreeViewItems.push(treeViewItem);
            }
        });

        _.each(treeViewItems, function (treeViewItem) {
            if (treeViewItem.parentId != null) {
                var parentTreeViewItem = treeViewItemsById[treeViewItem.parentId];
                parentTreeViewItem.children.push(treeViewItem);
            }
        });

        this.$tree.tree('loadData', rootTreeViewItems);

        // this should only happen the first time
        // after subsequent updates we will restore the previous set with 'setState'
        this.$tree.tree('setOption', 'autoOpen', false);

        _.defer(function() {
            self.selection.reselect();
        });

        this.$tree.tree('setState', state);
    };

    TreeView.prototype.getValue = function () {
        return this.selection.getSelection();
    };

    TreeView.prototype.clearValue = function () {
        this.value = null;
        this.$tree.tree('clear');
        this.selection.reset();
    };

    TreeView.prototype.setValue = function (update) {
        this.selection.replaceWith(update.value);
    };

    TreeView.prototype.supportsManyToManyData = function() {
        return this.data.multiselect;
    };

    return TreeView;
});

